import {Component, Inject, OnInit} from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import {MD_DIALOG_DATA, MdDialogRef} from '@angular/material';
import {FieldGroup} from '../../interfaces/FieldGroup';
import {EFieldGroupType} from '../../enums/e-field-group-type.enum';
import {EScheduleType} from '../../enums/e-schedule-type.enum';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {EServiceType, isMobileAppService} from '../../enums/e-service-type.enum';
import {strings} from '../../strings';
import {FormUtilities} from '../../../utilities/FormUtilities';

const animationTime = 500;
const easeIn = `${animationTime}ms ease-in`;
const easeOut = `${animationTime}ms ease-out`;

@Component({
  selector: 'app-field-group-editor-dialog',
  templateUrl: './field-group-editor-dialog.component.html',
  styleUrls: ['./field-group-editor-dialog.component.scss'],
  animations: [
    trigger('expansionPanelState', [
      transition(':enter', [
        style({ opacity: 0, height: 0}),
        animate(easeIn, style({ opacity: 1, height: 400}))
      ]),
      transition(':leave', [
        style({ opacity: 1, height: 400}),
        animate(easeOut, style({ opacity: 0, height: 0 } ))
      ])
    ]),
    trigger('easeOpacity', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate(easeIn, style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate(easeOut, style({ opacity: 0 } ))
      ])
    ])
  ]
})
export class FieldGroupEditorDialogComponent implements OnInit {

  public fieldGroupForm: FormGroup;
  public EScheduleType = EScheduleType;
  public EServiceType = EServiceType;
  public EFieldGroupType = EFieldGroupType;
  public signatureDescription = strings.fieldGroupSignatureWarning;
  public submitText = 'Update';

  constructor(@Inject(MD_DIALOG_DATA) public fieldGroup: FieldGroup,
              public dialogRef: MdDialogRef<FieldGroupEditorDialogComponent>,
              public formUtils: FormUtilities,
              private formBuilder: FormBuilder) { }

  ngOnInit() {
    if (this.fieldGroup === null) {
      this.submitText = 'Create';
      this.fieldGroup = this.makeFieldGroup();
    }
    this.fieldGroupForm = this.makeForm(this.fieldGroup);
  }

  makeFieldGroup(): FieldGroup {
    return {
      name: '',
      description: '',
      type: EFieldGroupType.FIELD_GROUP
    };
  }

  makeForm(fg: FieldGroup) {
    const serviceValidators = fg.type === EFieldGroupType.SERVICE ? Validators.required : [];
    const appServiceValidators = isMobileAppService(fg.service_type) ? Validators.required : [];

    return this.formBuilder.group({
      'name': new FormControl(fg.name, Validators.required),
      'app_name': new FormControl(fg.app_name),
      'description': new FormControl(fg.description),
      'type': new FormControl(fg.type, Validators.required),
      'signature': new FormControl(fg.signature),
      'schedule_type': new FormControl(fg.schedule_type, appServiceValidators ),
      'is_adhoc':  new FormControl(fg.is_adhoc, appServiceValidators),
      'service_type': new FormControl(fg.service_type, serviceValidators),
      'skip': new FormControl(fg.skip, serviceValidators),
      'hidden':  new FormControl(fg.hidden, serviceValidators),
    });
  }

  updateForm(fg: FieldGroup) {
    const serviceValidators = fg.type === EFieldGroupType.SERVICE ? Validators.required : [];
    const appServiceValidators = isMobileAppService(fg.service_type) ? Validators.required : [];
    this.fieldGroupForm.get('schedule_type').setValidators(appServiceValidators);
    this.fieldGroupForm.get('is_adhoc').setValidators(appServiceValidators);
    this.fieldGroupForm.get('service_type').setValidators(serviceValidators);
    this.fieldGroupForm.get('skip').setValidators(serviceValidators);
    this.fieldGroupForm.get('hidden').setValidators(serviceValidators);
  }

  public get shouldServicePanelShow() {
    if (!this.fieldGroupForm)
      return false;
    return Number(this.fieldGroupForm.value.type) === EFieldGroupType.SERVICE;
  }

  public change() {
    this.updateForm(this.fieldGroupForm.value);
  }

  public isMobileAppService() {
    if (!this.fieldGroupForm)
      return false;
    return isMobileAppService(this.fieldGroupForm.value.service_type);
  }

  public isTouchedAndHasError(formControlName: string, errorCode: string) {
    return this.formUtils.isTouchedAndHasError(this.fieldGroupForm, formControlName, errorCode);
  }

  onSubmit() {
    this.formUtils.markFormTouched(this.fieldGroupForm);
    if (this.fieldGroupForm.invalid)
      return;

    const fg: FieldGroup = { ...this.fieldGroupForm.value };
    if (fg.type === EFieldGroupType.FIELD_GROUP)
      fg.service_type = null;
    if (!isMobileAppService(fg.service_type)) {
      fg.schedule_type = null;
      fg.skip = false;
      fg.hidden = false;
      fg.is_adhoc = false;
    }


    this.dialogRef.close(fg);
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/components/field-group-editor-dialog/field-group-editor-dialog.component.ts